export default __webpack_public_path__ + "static/media/arbitrum.6273aceb.png";